import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {

  // baseUrl=environment.baseURL
  constructor(private dialog:MatDialog,@Inject(MAT_DIALOG_DATA) public data:any,private service:GlobalService) { }
allData:any;
  ngOnInit(): void {
    this.orderDetails()
    console.log('this.data')
    console.log(this.data)
    console.log(this.data)
  }


 orderDetails(){
  this.service.orderDetails(this.data.id).subscribe((res:any)=>{
    console.log('res')
    this.allData= res.order.order_items
    console.log(this.allData)
  })
 }

}
